import { ref, get } from "firebase/database";
import { database } from "../Components/firebase";

/**
 * Loads one gallery (`galleries/{galleryId}`) and its posts (`posts/{galleryId}`).
 * Posts are sorted newest-first (same convention as SingleAlbum / Test).
 *
 * @param {string} galleryId
 * @returns {Promise<{ gallery: object | null, posts: Array<{ imgURL?: string, timestamp?: number }> }>}
 */
export async function fetchGalleryWithPosts(galleryId) {
  if (!galleryId || typeof galleryId !== "string") {
    return { gallery: null, posts: [] };
  }

  const [gallerySnap, postsSnap] = await Promise.all([
    get(ref(database, "galleries/" + galleryId)),
    get(ref(database, "posts/" + galleryId)),
  ]);

  const gallery = gallerySnap.val() ?? null;
  const postsVal = postsSnap.val();
  const posts = postsVal
    ? Object.values(postsVal).sort(
        (a, b) => (b.timestamp ?? 0) - (a.timestamp ?? 0)
      )
    : [];

  return { gallery, posts };
}
